import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useEffect, useMemo, useRef, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import i18n from 'i18next';
import _ from 'lodash';
import PopupDialog from 'ui/components/popup-dialog';
import InputAutoComplete from './ui/input-auto-complete';
import ModalDialog from './ui/modal-dialog';
import Form from './ui/form';
import ah from '../utils/ajax-helper';
var t = i18n.getFixedT(null, 'user');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var initialState = JSON.parse(document.getElementById('initial-state').innerHTML || '{}');
var cfg = initialState.envCfg;

var ForgotPassword = function ForgotPassword() {
  var contextRoot = cfg.contextRoot;
  var imgRoot = contextRoot + '/images/';
  var params = new URLSearchParams(window.location.search);
  var token = params.get('token');
  var formRef = useRef();

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      systemMinPasswordLength = _useState2[0],
      setSystemMinPasswordLength = _useState2[1];

  var _useState3 = useState({
    newPd: '',
    confirmPd: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formData = _useState4[0],
      setFormData = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      info = _useState6[0],
      setInfo = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      error = _useState8[0],
      setError = _useState8[1];

  var getSystemMinPasswordLength = function getSystemMinPasswordLength() {
    ah.get("".concat(cfg.contextRoot, "/system-config/system.min.password.length")).then(function (result) {
      if (result.code !== -1) {
        setSystemMinPasswordLength(result.data.value.value);
      }
    });
  };

  var handleChange = function handleChange(value) {
    setFormData(_objectSpread(_objectSpread({}, formData), {}, {
      newPd: value.newPd,
      confirmPd: value.confirmPd
    }));
  };

  var handleError = function handleError() {
    var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    setInfo(err);
    setError(err !== '');
  };

  var handleFormValidation = function handleFormValidation() {
    window.requestAnimationFrame(function () {
      var formValid = ReactDOM.findDOMNode(formRef.current).getElementsByClassName('invalid').length == 0;

      if (formValid) {
        return handleError();
      }
    });
  };

  var pattern = useMemo(function () {
    return new RegExp("^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&/=?_.,:;\\-])).{".concat(systemMinPasswordLength, ",}|\\{\\(enc\\)\\}.*$"));
  }, [systemMinPasswordLength]);

  var handleConfirm = function handleConfirm() {
    var newPd = formData.newPd,
        confirmPd = formData.confirmPd;

    if (_.isEmpty(newPd) || _.isEmpty(confirmPd)) {
      return handleError(et('txt-fill-out-required'));
    }

    if (newPd !== confirmPd) {
      return handleError(t('txt-password-not-match'));
    }

    ah.post("".concat(cfg.contextRoot, "/user/reset"), JSON.stringify({
      token: token,
      newPd: newPd
    }), null, true).then(function (result) {
      if (result.code < 0) {
        return handleError(et(result.messageCode));
      }

      PopupDialog.alert({
        display: t('txt-password-reset-succeed'),
        confirmText: gt('global.lbl-answer-ok'),
        act: function act() {
          window.location.href = "".concat(cfg.contextRoot, "/app");
        }
      });
    }).catch(function (err) {
      return handleError(err.message);
    });
  };

  useEffect(function () {
    getSystemMinPasswordLength();
  }, []);
  useEffect(function () {
    handleFormValidation();
  }, [formData]);
  useLayoutEffect(function () {
    document.getElementById('g-side-nav').remove();
  }, []);
  var actions = {};

  _.set(actions, 'confirm', {
    text: gt('global.lbl-answer-ok'),
    className: 'button-success',
    handler: handleConfirm
  });

  if (!token) {
    window.location.href = "".concat(cfg.contextRoot, "/app");
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    id: "g-login",
    className: "c-center global",
    style: {
      backgroundImage: "url(".concat(imgRoot, "img_login_bg.png)"),
      backgroundSize: 'cover'
    }
  }, /*#__PURE__*/React.createElement(ModalDialog, {
    id: "g-reset-password",
    title: t('dlg-reset-password'),
    global: true,
    info: info,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "g-reset-password-form",
    ref: formRef,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: {
      newPd: {
        label: t('lbl-new-password'),
        editor: InputAutoComplete,
        props: {
          type: 'password',
          validate: {
            required: true,
            pattern: pattern,
            t: function t(code) {
              return et("txt-".concat(code));
            }
          }
        }
      },
      confirmPd: {
        label: t('lbl-re-new-password'),
        editor: InputAutoComplete,
        props: {
          type: 'password',
          required: true,
          validate: {
            t: function t(code) {
              return et("txt-".concat(code));
            }
          }
        }
      }
    },
    onChange: handleChange,
    value: formData,
    footer: t('txt-password-pattern', {
      length: parseInt(systemMinPasswordLength, 10)
    })
  })));
};

export default ForgotPassword;